// src/TermsOfService.js
import React from "react";

function TermsOfService() {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Terms of Service</h1>

      <p>
        Welcome to "iLoveScan: AI PDF Editor Scan" (the "App"). By using our
        App, you agree to these Terms of Service (the "Terms"). Please read them
        carefully.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using the App, you agree to comply with and be bound by
        these Terms. If you do not agree with these Terms, you should not use
        the App.
      </p>

      <h2>2. Use of the App</h2>
      <p>
        The App provides text scanning and document reading services, including
        PDFs and other document types. You agree to use the App only for lawful
        purposes and in accordance with these Terms.
      </p>

      <h2>3. No Collection of Personal Data</h2>
      <p>
        We do not collect, store, or share any personal information about you.
        All data processed by the App is handled locally on your device and is
        not stored or shared with third parties.
      </p>

      <h2>4. Intellectual Property</h2>
      <p>
        All content and materials available on the App, including but not
        limited to text, graphics, logos, and software, are the property of
        Trustica Labs or its licensors and are protected by copyright,
        trademark, and other intellectual property laws.
      </p>

      <h2>5. Prohibited Conduct</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the App for any illegal or unauthorized purpose.</li>
        <li>
          Interfere with or disrupt the App or servers connected to the App.
        </li>
        <li>
          Attempt to gain unauthorized access to any part of the App or its
          systems.
        </li>
      </ul>

      <h2>6. Disclaimers</h2>
      <p>
        The App is provided "as is" and "as available" without any warranties of
        any kind. We disclaim all warranties, express or implied, including but
        not limited to implied warranties of merchantability and fitness for a
        particular purpose. We do not guarantee that the App will be
        uninterrupted or error-free.
      </p>

      <h2>7. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, Trustica Labs shall not be
        liable for any indirect, incidental, special, consequential, or punitive
        damages, or any loss of profits or data, arising out of or in connection
        with your use of the App.
      </p>

      <h2>8. Changes to Terms</h2>
      <p>
        We may update these Terms from time to time. Any changes will be posted
        on this page with an updated effective date. Your continued use of the
        App after any such changes constitutes your acceptance of the new Terms.
      </p>

      <h2>9. Termination</h2>
      <p>
        We reserve the right to terminate or suspend your access to the App at
        our sole discretion, without notice, for any reason, including but not
        limited to a breach of these Terms.
      </p>

      <h2>10. Contact Us</h2>
      <p>
        If you have any questions about these Terms or the App, please contact
        us at:
      </p>
      <p>
        Email:{" "}
        <a href="mailto:trusticalabs@gmail.com">trusticalabs@gmail.com</a>
      </p>

      <h2>11. Governing Law</h2>
      <p>
        These Terms are governed by and construed in accordance with the laws of
        [Your Country/State], without regard to its conflict of law principles.
      </p>
    </div>
  );
}

export default TermsOfService;
